import React, { useEffect, useState } from "react";
import useCustomerDocs from "../../../hooks/useCustomerDocs";
import { FaSearch } from "react-icons/fa";
import { Input } from "../../../components/ui";
import { IoMdCloseCircleOutline } from "react-icons/io";
import EmptyProfile from "../../../assets/images/profile.jpg";
import useGetBankPartnersData from "../useGetbankPartners";
import { TMandiEmployeeDetais } from "../../../types/markets";

const MandiHeadSelection: React.FC<{
  onChange: (rm: any) => void;
  onClear: () => void;
  rmId: number | string;
  searchTerm: string;
  setSearchTerm: any;
}> = ({ onChange, onClear, rmId, searchTerm, setSearchTerm }) => {
  const { getMandiEmployeesData, mandiEmployeesData } =
    useGetBankPartnersData();

  const [selectedOpt, setSelectedOpt] = useState<number | null>(null);
  const [relationshipManager, setRelationshipManager] = useState<
    TMandiEmployeeDetais[]
  >([]);
  useEffect(() => {
    setRelationshipManager(mandiEmployeesData);
  }, [mandiEmployeesData]);
  const clearSearch = () => {
    setSelectedOpt(0);
    setSearchTerm("");
    onClear();
  };

  const handleOptionClick = (rm: any) => {
    // setSearchTerm(rm.name);
    let index = relationshipManager?.findIndex((r) => r.onoId == rm.onoId);
    let updatedManagerData = [...relationshipManager];
    updatedManagerData?.splice(index, 1);
    updatedManagerData?.splice(0, 0, rm);
    onChange(rm);
  };

  const filteredOptions = relationshipManager.filter((option) =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    getMandiEmployeesData();
  }, []);
  return (
    <div>
      <div>
        <div className=" relative m-2">
          <FaSearch
            className=" absolute color-primary"
            size={15}
            style={{ top: "14px", left: "6px" }}
          />
          <Input
            type="text"
            palceholder="Search RM Name"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            inputStyle={{
              textIndent: "14px",
              padding: "8px 5px",
            }}
            style={{
              width: "100%",
            }}
          />

          <div>
            <IoMdCloseCircleOutline
              onClick={() => {
                clearSearch();
              }}
              className="absolute color-primary cursor-pointer w-10"
              style={{
                top: "32%",
                right: "1rem",
                fontSize: "1.2rem",
                color: "gray",
                cursor: "pointer",
              }}
            />
          </div>
        </div>

        <div
          className="overflow-y-auto p-[5px]"
          style={{ height: "calc(50vh - 10rem)" }}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, id) => (
              <div
                onClick={() => handleOptionClick(option)}
                className="cursor-pointer p-1"
              >
                <div
                  className={`flex border items-center br-10 gap-2 p-2 ${
                    rmId === option.onoId
                      ? "bg-light-primary border-primary"
                      : "bg-white"
                  } hv-primary cursor-pointer`}
                >
                  <div>
                    {option.profilePic ? (
                      <img src={option.profilePic} className="w-8 h-8" />
                    ) : (
                      <img src={EmptyProfile} className="w-8 h-8 " />
                    )}
                  </div>
                  <div className="flex flex-col">
                    <span className="fs-14">{option?.name}</span>

                    <span className="fs-12 color-sub-text font-semibold">
                      {option?.mobile}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="flex items-center justify-center h-full">
              <span className="font-semibold">No RM found</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MandiHeadSelection;
